'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$69() {
  this.bm6 = null;
  this.bm7 = false;
}
export { $c_Lpresto_PrestoRouter$$anon$69 as $c_Lpresto_PrestoRouter$$anon$69 };
$p = $c_Lpresto_PrestoRouter$$anon$69.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$69;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$69() {
}
export { $h_Lpresto_PrestoRouter$$anon$69 as $h_Lpresto_PrestoRouter$$anon$69 };
$h_Lpresto_PrestoRouter$$anon$69.prototype = $p;
$p.bW = (function() {
  if ((!this.bm7)) {
    this.bm6 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_T$package$EmptyTuple$();
    this.bm7 = true;
  }
  return this.bm6;
});
$p.P = (function() {
  return this.bW();
});
var $d_Lpresto_PrestoRouter$$anon$69 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$69, "presto.PrestoRouter$$anon$69", ({
  OB: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$69 as $d_Lpresto_PrestoRouter$$anon$69 };
//# sourceMappingURL=presto.-Presto-Router$$anon$69.js.map
